module.exports = __webpack_public_path__ + "static/media/logo.fddce607.png";


//////////////////
// WEBPACK FOOTER
// /src/images/logo.png
// module id = 144
// module chunks = 0